import LegacyButton from "legacy/LegacyButton"
import ContractChargeItemModal from "legacy/charge-item/ContractChargeItemModal"
import ContractGroupV2PanelPage from "legacy/contract-groups-v2/ContractGroupV2PanelPage"
import { humanize } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

// Note: Amplitude is loaded globally
// Note: $context is loaded globally

class ContractGroupV2Charges extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      chargeItemsView: props.form.posItemsData || [],
      chargeItemEditing: null,
      currentChargeItem: null,
      currentChargeItemIndex: null,
    }
    this.next = this.next.bind(this)
    this.addChargeItemsFromModal = this.addChargeItemsFromModal.bind(this)
    this.openEditModal = this.openEditModal.bind(this)
    this.removeChargeItem = this.removeChargeItem.bind(this)
  }

  fetchData() {
    return { posItemsData: this.state.chargeItemsView }
  }

  componentWillUnmount() {
    Amplitude.trackEvent("contracts_v2:charges_complete")
    this.props.update({ posItemsData: this.state.chargeItemsView })
  }

  next() {
    this.props.route.goNext()
  }

  formatNewItem(chargeItemFromModal) {
    return {
      ...chargeItemFromModal,
      pricing: chargeItemFromModal.unitPrice * chargeItemFromModal.quantity,
    }
  }

  removeChargeItem(index) {
    this.setState({
      chargeItemsView: this.state.chargeItemsView.filter(
        (_, idx) => idx !== index
      ),
    })
  }

  addChargeItemsFromModal(chargeItemFromModal) {
    if (this.state.chargeItemEditing) {
      // replace the charge item at the index if we're editing
      const newChargeItems = this.state.chargeItemsView.map((item, idx) =>
        idx === this.state.currentChargeItemIndex
          ? this.formatNewItem(chargeItemFromModal)
          : item
      )
      this.setState({
        chargeItemEditing: false,
        chargeItemsView: newChargeItems,
        currentChargeItem: null,
        currentChargeItemIndex: null,
      })
    } else {
      this.setState({
        chargeItemsView: this.state.chargeItemsView.concat(
          this.formatNewItem(chargeItemFromModal)
        ),
      })
    }
  }

  openEditModal(idx, chargeItem) {
    this.setState({
      currentChargeItem: chargeItem,
      currentChargeItemIndex: idx,
    })
    this.setState({ showModal: true, chargeItemEditing: true })
  }

  render() {
    return (
      <ContractGroupV2PanelPage
        hasNext={this.props.route.hasNext}
        hasPrevious={this.props.route.hasPrevious}
        goNext={this.next}
        goPrevious={this.props.route.goPrevious}
        saving={this.props.saving}
      >
        <div>
          <label>Charges</label>
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="bg-gray-200 p-1">Category</th>
                <th className="bg-gray-200 py-1">Name</th>
                <th className="bg-gray-200 py-1">Pricing</th>
                <th className="bg-gray-200 py-1">Tax</th>
                <th className="bg-gray-200 py-1">Frequency</th>
                <th className="bg-gray-200 p-1"></th>
              </tr>
            </thead>
            <tbody>
              {this.state.chargeItemsView &&
                this.state.chargeItemsView.map((charge, idx) => (
                  <tr key={`charge.name-${idx}`}>
                    <td className="py-2">
                      {charge.category && humanize(charge.category)}
                    </td>
                    <td className="py-2">{charge.name}</td>
                    <td className="py-2">
                      ${parseFloat(charge.pricing).toFixed(2)}
                    </td>
                    <td className="py-2">
                      {charge.taxRate &&
                        `${parseFloat(charge.taxRate).toFixed(2)}%`}
                    </td>
                    <td className="py-2">
                      {charge.frequency && humanize(charge.frequency)}
                    </td>
                    <td className="space-x-2 py-2">
                      <LegacyButton
                        onClick={() => this.openEditModal(idx, charge)}
                        type="ghost"
                      >
                        Edit
                      </LegacyButton>
                      <LegacyButton
                        onClick={() => this.removeChargeItem(idx)}
                        type="ghost"
                      >
                        Delete
                      </LegacyButton>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div className="mt-2 flex flex-col items-start">
            {(!this.state.chargeItemsView ||
              this.state.chargeItemsView.length === 0) && (
              <div className="self-center">
                <p className="text-gray-500">There are no charges here</p>
              </div>
            )}
            <div className="self-center">
              {/* Added with placeholder pos item */}
              <ContractChargeItemModal
                reservation={{ startDate: "1/1/2021", endDate: "1/1/2022" }}
                startDate={this.props.form.startDate}
                endDate={this.props.form.endDate}
                chargeItems={$context.posItems}
                billings={$context.posItemBillings}
                frequencies={$context.posItemFrequencies}
                saveCallback={this.addChargeItemsFromModal}
                closeCallback={() =>
                  this.setState({ showModal: false, chargeItemEditing: false })
                }
                showEditModal={this.state.showModal}
                selectedItem={this.state.currentChargeItem}
              />
            </div>
          </div>
        </div>
      </ContractGroupV2PanelPage>
    )
  }
}

ContractGroupV2Charges.propTypes = {
  form: PropTypes.shape({
    posItemsData: PropTypes.array,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
  update: PropTypes.func.isRequired,
  route: PropTypes.shape({
    hasNext: PropTypes.bool,
    hasPrevious: PropTypes.bool,
    goNext: PropTypes.func,
    goPrevious: PropTypes.func,
  }).isRequired,
  saving: PropTypes.bool,
}

export default ContractGroupV2Charges
